export namespace RegExpList {
  export const allowedCharacters = /^[A-Za-z0-9\@\#\$\%\^\&\*\-\_\!\+\=\[\]\{\}\s]{1,}$/;

  export const allowedCharactersCyrillic = /^[A-Za-z0-9А-Яа-яЁёІіЇїЄєҐґЎў\@\#\$\%\^\&\*\-\_\!\+\=\[\]\{\}\s]{1,}$/;

  export const capitalLetter = /[A-Z]{1,}/;

  export const lowercaseLetter = /[a-z]{1,}/;

  export const allowedSymbol = /[\@\#\$\%\^\&\*\-\_\!\+\=\[\]\{\}]{1,}/;

  export const numbers = /[0-9]{1,}/;

  export const inputNumber = /[0-9]{1,}|Backspace|Delete/;

  export const segmentField = /segment[0-9]{1,}/;

  export const nonLatin = /[^\x00-\x7F]/;
}
